import { rpc } from './client.js';

export const sendHandover = (token, a) =>
  rpc('sps_handover', {
    p_token: token,
    p_client_id: a.clientId,
    p_family_key: a.familyKey,
    p_scanned_member_id: a.scannedMemberId ?? null,
    p_collected_member_id: a.collectedMemberId ?? null,
    p_collected_name: a.collectedName,
    p_designated_name: a.designatedName ?? null,
    p_substitute: !!a.substitute,
    p_reason: a.reason ?? null,
    p_client_at: a.clientAt ?? new Date().toISOString(),
    p_device: a.device ?? null,
  });

export const voidHandover = (token, id, reason) =>
  rpc('sps_void', { p_token: token, p_handover_id: id, p_reason: reason });
